import { createIcon } from '~/utils';

export const TearDropIcon = createIcon({
  viewBox: '0 0 14 14',
  path: (
    <path d='M12.6875 6.78125C12.6859 8.23116 12.1092 9.62124 11.084 10.6465C10.0587 11.6717 8.66866 12.2484 7.21875 12.25H2.625C2.39294 12.25 2.17038 12.1578 2.00628 11.9937C1.84219 11.8296 1.75 11.6071 1.75 11.375V6.78125C1.75 5.33085 2.32617 3.93985 3.35176 2.91426C4.37735 1.88867 5.76835 1.3125 7.21875 1.3125C8.66915 1.3125 10.0602 1.88867 11.0857 2.91426C12.1113 3.93985 12.6875 5.33085 12.6875 6.78125Z' />
  ),
});
